export enum filtersFieldsNameEnum {
  datevNumberId = 'datevNumberId',
  dataType = 'dataType',
  year = 'year',
}
